import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tabs custom-textarea" }
const _hoisted_2 = { class: "tab" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "company"
}, null, -1)
const _hoisted_4 = {
  class: "tab-label",
  for: "company"
}
const _hoisted_5 = { class: "flex justify-between w-full" }
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = { class: "grid cols-12 gap-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex section-title col-span-12" }, " Dados Cadastrais ", -1)
const _hoisted_9 = { class: "col-span-12 md:col-span-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " CNPJ ", -1)
const _hoisted_11 = { class: "data" }
const _hoisted_12 = {
  key: 0,
  class: "col-span-12 md:col-span-6"
}
const _hoisted_13 = { class: "label flex flex-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, " E-mail do pré-cadastro ", -1)
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = { class: "data" }
const _hoisted_17 = { class: "col-span-12 md:col-span-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Razão Social ", -1)
const _hoisted_19 = { class: "data" }
const _hoisted_20 = { class: "col-span-12 md:col-span-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Nome Fantasia ", -1)
const _hoisted_22 = { class: "data" }
const _hoisted_23 = { class: "col-span-12 md:col-span-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Inscrição Estadual ", -1)
const _hoisted_25 = { class: "data" }
const _hoisted_26 = { class: "col-span-12 md:col-span-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " CNAE ", -1)
const _hoisted_28 = { class: "data" }
const _hoisted_29 = { class: "col-span-12 md:col-span-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Regime Tributário ", -1)
const _hoisted_31 = { class: "data" }
const _hoisted_32 = { class: "col-span-12 md:col-span-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Faturamento Mensal ", -1)
const _hoisted_34 = { class: "data" }
const _hoisted_35 = { class: "col-span-12 md:col-span-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Data de Abertura ", -1)
const _hoisted_37 = { class: "data" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "section-title col-span-12" }, "Dados para Contato", -1)
const _hoisted_40 = { class: "col-span-12 md:col-span-6" }
const _hoisted_41 = { class: "label flex" }
const _hoisted_42 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_43 = { class: "data" }
const _hoisted_44 = { class: "col-span-12 md:col-span-6" }
const _hoisted_45 = { class: "label" }
const _hoisted_46 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_47 = { class: "data" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "section-title col-span-12" }, " Dados do Endereço ", -1)
const _hoisted_50 = {
  key: 1,
  class: "col-span-12"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = {
  key: 2,
  class: "col-span-12"
}
const _hoisted_54 = {
  key: 3,
  class: "w-full col-span-12 grid cols-12 gap-5"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "section-title col-span-12" }, " Documentos ", -1)
const _hoisted_57 = { class: "col-span-12 md:col-span-6" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Contrato de Adesão ", -1)
const _hoisted_59 = { class: "data" }
const _hoisted_60 = {
  key: 0,
  class: "tab"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "representatives"
}, null, -1)
const _hoisted_62 = {
  class: "tab-label",
  for: "representatives"
}
const _hoisted_63 = { class: "justify-between flex w-full" }
const _hoisted_64 = { class: "tab-content" }
const _hoisted_65 = { class: "flex section-title col-span-12" }
const _hoisted_66 = { class: "col-span-12 md:col-span-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " CPF ", -1)
const _hoisted_68 = { class: "data" }
const _hoisted_69 = { class: "col-span-12 md:col-span-6" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " RG ", -1)
const _hoisted_71 = { class: "data" }
const _hoisted_72 = { class: "col-span-12 md:col-span-6" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Nome Completo ", -1)
const _hoisted_74 = { class: "data" }
const _hoisted_75 = { class: "col-span-12 md:col-span-6" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Nome da Mãe ", -1)
const _hoisted_77 = { class: "data" }
const _hoisted_78 = { class: "col-span-12 md:col-span-6" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Data de Nascimento ", -1)
const _hoisted_80 = { class: "data" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_82 = { class: "section-title col-span-12" }
const _hoisted_83 = { class: "col-span-12 md:col-span-6" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "label flex" }, " E-mail ", -1)
const _hoisted_85 = { class: "data" }
const _hoisted_86 = { class: "col-span-12 md:col-span-6" }
const _hoisted_87 = { class: "label" }
const _hoisted_88 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_89 = { class: "data" }
const _hoisted_90 = { class: "col-span-12 md:col-span-6" }
const _hoisted_91 = { class: "label flex" }
const _hoisted_92 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_93 = { class: "data" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_95 = { class: "section-title col-span-12" }
const _hoisted_96 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_99 = {
  key: 1,
  class: "w-full col-span-12 border-t border border-grey-300"
}
const _hoisted_100 = {
  key: 1,
  class: "tab"
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "responsavel"
}, null, -1)
const _hoisted_102 = {
  class: "tab-label",
  for: "responsavel"
}
const _hoisted_103 = { class: "flex justify-between w-full" }
const _hoisted_104 = { class: "tab-content" }
const _hoisted_105 = { class: "grid grid cols-12 gap-5" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "flex section-title col-span-12" }, " Dados Cadastrais ", -1)
const _hoisted_107 = { class: "col-span-12 md:col-span-6" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " CPF ", -1)
const _hoisted_109 = { class: "data" }
const _hoisted_110 = { class: "col-span-12 md:col-span-6" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Nome Completo ", -1)
const _hoisted_112 = { class: "data" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "section-title col-span-12" }, "Dados para Contato", -1)
const _hoisted_115 = { class: "col-span-12 md:col-span-6" }
const _hoisted_116 = { class: "label flex" }
const _hoisted_117 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_118 = { class: "data" }
const _hoisted_119 = { class: "col-span-12 md:col-span-6" }
const _hoisted_120 = { class: "label flex" }
const _hoisted_121 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_122 = { class: "data" }
const _hoisted_123 = {
  key: 2,
  class: "tab"
}
const _hoisted_124 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "tecnico"
}, null, -1)
const _hoisted_125 = {
  class: "tab-label",
  for: "tecnico"
}
const _hoisted_126 = { class: "flex justify-between w-full" }
const _hoisted_127 = { class: "tab-content" }
const _hoisted_128 = { class: "grid grid cols-12 gap-5" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "flex section-title col-span-12" }, " Dados Cadastrais ", -1)
const _hoisted_130 = { class: "col-span-12 md:col-span-6" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " CPF ", -1)
const _hoisted_132 = { class: "data" }
const _hoisted_133 = { class: "col-span-12 md:col-span-6" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Nome Completo ", -1)
const _hoisted_135 = { class: "data" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "w-full col-span-12 border-t border border-grey-300" }, null, -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "section-title col-span-12" }, "Dados para Contato", -1)
const _hoisted_138 = { class: "col-span-12 md:col-span-6" }
const _hoisted_139 = { class: "label flex" }
const _hoisted_140 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_141 = { class: "data" }
const _hoisted_142 = { class: "col-span-12 md:col-span-6" }
const _hoisted_143 = { class: "label flex" }
const _hoisted_144 = {
  key: 0,
  class: "text-red-500 ml-4 font-light"
}
const _hoisted_145 = { class: "data" }
const _hoisted_146 = { class: "tab" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "mediatorFee"
}, null, -1)
const _hoisted_148 = {
  class: "tab-label",
  for: "mediatorFee"
}
const _hoisted_149 = { class: "flex justify-between w-full" }
const _hoisted_150 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_151 = { class: "flex flex-row gap-4" }
const _hoisted_152 = { class: "w-full" }
const _hoisted_153 = { class: "data" }
const _hoisted_154 = { class: "flex items-center justify-center gap-4" }
const _hoisted_155 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_156 = { class: "grid grid cols-12 gap-5" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "flex section-title col-span-12" }, " Dados Cadastrais ", -1)
const _hoisted_158 = { class: "col-span-12 md:col-span-6" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Tarifa padrão ", -1)
const _hoisted_160 = { class: "data" }
const _hoisted_161 = {
  key: 3,
  class: "tab"
}
const _hoisted_162 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "onboarding"
}, null, -1)
const _hoisted_163 = {
  class: "tab-label",
  for: "onboarding"
}
const _hoisted_164 = { class: "flex justify-between w-full" }
const _hoisted_165 = { class: "tab-content" }
const _hoisted_166 = { class: "flex flex-row gap-4" }
const _hoisted_167 = { class: "w-full" }
const _hoisted_168 = { class: "data" }
const _hoisted_169 = { class: "flex items-center justify-center gap-4" }
const _hoisted_170 = ["hidden"]
const _hoisted_171 = {
  key: 0,
  class: "col-span-10 flex h-full w-full items-center justify-end gap-4 mt-5"
}
const _hoisted_172 = { class: "w-8/10 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("div", { class: "text-black text-2xl" }, " Protocolo de cadastro ", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("p", { class: "my-3 text-base" }, "Deseja enviar um e-mail para receber o protocolo de cadastro?", -1)
const _hoisted_175 = { class: "flex items-center mt-4 h-full w-full justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(" Dados da Empresa "),
            ($data.invalidSoftwareHouse)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  icon: $data.alert,
                  class: "text-red-500 my-auto ml-auto mr-5 bg-white rounded-full"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString($options.applyMask('CNPJ', $props.data.cnpj)), 1)
            ]),
            ($props.data.preRegister && $props.data.preRegister.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Tooltip, { text: "Este e-mail é utilizado para criar a conta do Tecnopay e a conta do TecnoAccount" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString($props.data.preRegister.email), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString($props.data.corporateName), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString($props.data.fantasyName ? $props.data.fantasyName : "Sem nome fantasia"), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString($props.data.stateRegistration ? $options.applyMask('IE', $props.data.stateRegistration) :
            "Inscrição estadual não cadastrada"), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, _toDisplayString($options.applyMask('CNAE', $props.data.cnae)), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, _toDisplayString($data.regimes[$props.data.taxRegime]), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, _toDisplayString($props.data.monthlyBilling ?
            Intl.NumberFormat('pt-br',
              {
                style: 'currency', currency: 'BRL'
              }).format($props.data.monthlyBilling) : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, _toDisplayString($props.data.openingDate ? $options.applyDateFormat($props.data.openingDate) : ''), 1)
            ]),
            _hoisted_38,
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createTextVNode(" E-mail "),
                ($props.data.email && !$options.isValid($props.data.email, 'software-house'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createTextVNode(" Validação pendente "),
                      _createVNode(_component_FontAwesomeIcon, {
                        icon: $data.alert,
                        class: "text-red-500 my-auto ml bg-white rounded-full"
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, _toDisplayString($props.data.email ? $props.data.email : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createTextVNode(" Telefone "),
                ($props.data.phone && !$options.isValid($props.data.phone, 'software-house'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createTextVNode(" Validação pendente "),
                      _createVNode(_component_FontAwesomeIcon, {
                        icon: $data.alert,
                        class: "text-red-500 my-auto ml bg-white rounded-full"
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_47, _toDisplayString($props.data.phone ? $options.applyMask('Telefone', $props.data.phone.replace(/\+55/g,
            '')) : ''), 1)
            ]),
            _hoisted_48,
            _hoisted_49,
            ($props.data.address)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createTextVNode(_toDisplayString($props.data.address) + ", " + _toDisplayString($props.data.number) + ". " + _toDisplayString($props.data.complement ? '(' +
            $props.data.complement + ')' : '') + " ", 1),
                  _hoisted_51,
                  _createTextVNode(" " + _toDisplayString($props.data.district) + ", " + _toDisplayString($props.data.city) + " - " + _toDisplayString($props.data.state) + " ", 1),
                  _hoisted_52,
                  _createTextVNode(" " + _toDisplayString($options.applyMask('CEP', $props.data.zipCode)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString($props.data.address), 1)),
            (['assinatura_contrato', 'cadastro_concluido', 'erro'].includes($props.data.status))
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_Button, {
                        disabled: $data.downloadInProgress,
                        label: "Baixar",
                        icon: $data.buttonIcons.download.icon,
                        width: "w-48 -lg:w-full",
                        type: "button",
                        onClick: $options.downloadContract
                      }, null, 8, ["disabled", "icon", "onClick"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      ($props.data.representatives && $props.data.representatives.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("label", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createTextVNode(" Dados dos Representantes Legais "),
                ($data.invalidRepresentante)
                  ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 0,
                      icon: $data.alert,
                      class: "text-red-500 my-auto ml-auto mr-5 bg-white rounded-full"
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.representatives, (representative, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "grid grid-cols-12 gap-5"
                }, [
                  _createElementVNode("div", _hoisted_65, " Dados Cadastrais " + _toDisplayString(representative.isMain ? '(Representante Principal)' : ''), 1),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, _toDisplayString($options.applyMask('CPF', representative.cpf)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("div", _hoisted_71, _toDisplayString($options.applyMask('RG', representative.rg)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, _toDisplayString(representative.fullName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createElementVNode("div", _hoisted_77, _toDisplayString(representative.motherName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, _toDisplayString(representative.birthday ? $options.applyDateFormat(representative.birthday) : ''), 1)
                  ]),
                  _hoisted_81,
                  _createElementVNode("div", _hoisted_82, "Dados para Contato " + _toDisplayString(representative.isMain ? '(Representante Principal)' : ''), 1),
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, _toDisplayString(representative.email), 1)
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createTextVNode(" Telefone "),
                      (representative.phone && !$options.isValid(representative.phone, 'representative'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _createTextVNode(" Validação pendente "),
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: $data.alert,
                              class: "text-red-500 my-auto ml bg-white rounded-full"
                            }, null, 8, ["icon"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_89, _toDisplayString(representative.phone ? $options.applyMask('Telefone', representative.phone.replace(/\+55/g, '')) : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createTextVNode(" Celular "),
                      (representative.cellPhone && !$options.isValid(representative.cellPhone, 'representative'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                            _createTextVNode(" Validação pendente "),
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: $data.alert,
                              class: "text-red-500 my-auto ml bg-white rounded-full"
                            }, null, 8, ["icon"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_93, _toDisplayString(representative.cellPhone ? $options.applyMask('Celular', representative.cellPhone.replace(/\+55/g, '')) : ''), 1)
                  ]),
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, " Dados do Endereço " + _toDisplayString(representative.isMain ? '(Representante Principal)' : ''), 1),
                  (representative.address)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                        _createTextVNode(_toDisplayString(representative.address) + ", " + _toDisplayString(representative.number) + ". " + _toDisplayString(representative.complement ? '(' + representative.complement + ')' : '') + " ", 1),
                        _hoisted_97,
                        _createTextVNode(" " + _toDisplayString(representative.district) + ", " + _toDisplayString(representative.city) + " - " + _toDisplayString(representative.state) + " ", 1),
                        _hoisted_98,
                        _createTextVNode(" " + _toDisplayString($options.applyMask('CEP', representative.zipCode)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (index < $props.data.representatives.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      ($data.responsible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
            _hoisted_101,
            _createElementVNode("label", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createTextVNode(" Dados do Responsável "),
                ($data.invalidResponsavel)
                  ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 0,
                      icon: $data.alert,
                      class: "text-red-500 my-auto ml-auto mr-5 bg-white rounded-full"
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _hoisted_106,
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createElementVNode("div", _hoisted_109, _toDisplayString($options.applyMask('CPF', $data.responsible.cpf)), 1)
                ]),
                _createElementVNode("div", _hoisted_110, [
                  _hoisted_111,
                  _createElementVNode("div", _hoisted_112, _toDisplayString($data.responsible.fullName), 1)
                ]),
                _hoisted_113,
                _hoisted_114,
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _createTextVNode(" E-mail "),
                    ($data.responsible.email && !$options.isValid($data.responsible.email, 'responsavel'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                          _createTextVNode(" Validação pendente "),
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: $data.alert,
                            class: "text-red-500 my-auto ml bg-white rounded-full"
                          }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_118, _toDisplayString($data.responsible.email), 1)
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _createTextVNode(" Celular "),
                    ($data.responsible.cellPhone && !$options.isValid($data.responsible.cellPhone, 'responsavel'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                          _createTextVNode(" Validação pendente "),
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: $data.alert,
                            class: "text-red-500 my-auto ml bg-white rounded-full"
                          }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_122, _toDisplayString($data.responsible.cellPhone ? $options.applyMask('Celular', $data.responsible.cellPhone.replace(/\+55/g, '')) : ''), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($data.technicalResponsible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
            _hoisted_124,
            _createElementVNode("label", _hoisted_125, [
              _createElementVNode("div", _hoisted_126, [
                _createTextVNode(" Dados do Responsável Técnico "),
                ($data.invalidResponsavelTecnico)
                  ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 0,
                      icon: $data.alert,
                      class: "text-red-500 my-auto ml-auto mr-5 bg-white rounded-full"
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _hoisted_129,
                _createElementVNode("div", _hoisted_130, [
                  _hoisted_131,
                  _createElementVNode("div", _hoisted_132, _toDisplayString($options.applyMask('CPF', $data.technicalResponsible.cpf)), 1)
                ]),
                _createElementVNode("div", _hoisted_133, [
                  _hoisted_134,
                  _createElementVNode("div", _hoisted_135, _toDisplayString($data.technicalResponsible.fullName), 1)
                ]),
                _hoisted_136,
                _hoisted_137,
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createTextVNode(" E-mail "),
                    ($data.technicalResponsible.email &&!$options.isValid($data.technicalResponsible.email, 'tecnico'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                          _createTextVNode(" Validação pendente "),
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: $data.alert,
                            class: "text-red-500 my-auto ml bg-white rounded-full"
                          }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_141, _toDisplayString($data.technicalResponsible.email), 1)
                ]),
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _createTextVNode(" Celular "),
                    ($data.technicalResponsible.cellPhone && !$options.isValid($data.technicalResponsible.cellPhone, 'tecnico'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                          _createTextVNode(" Validação pendente "),
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: $data.alert,
                            class: "text-red-500 my-auto ml bg-white rounded-full"
                          }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_145, _toDisplayString($data.technicalResponsible.cellPhone ? $options.applyMask('Celular', $data.technicalResponsible.cellPhone.replace(/\+55/g, '')) : ''), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_146, [
        _hoisted_147,
        _createElementVNode("label", _hoisted_148, [
          _createElementVNode("div", _hoisted_149, [
            _createTextVNode(" Tarifas "),
            ($data.invalidResponsavel)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  icon: $data.alert,
                  class: "text-red-500 my-auto ml-auto mr-5 bg-white rounded-full"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ])
        ]),
        ($props.isEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
              _createElementVNode("div", _hoisted_151, [
                _createElementVNode("div", _hoisted_152, [
                  _createElementVNode("div", _hoisted_153, [
                    _createVNode(_component_CustomInput, {
                      label: "Tarifa padrão",
                      name: "mediatorFee",
                      type: "currency",
                      validation: $data.formValidation.inputMediatorFee,
                      class: "col-span-12 sm:col-span-1 lg:col-span-4 xl:col-span-3",
                      value: $props.mediatorFee,
                      onChange: $options.changeField
                    }, null, 8, ["validation", "value", "onChange"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_154, [
                  _createVNode(_component_PrimaryButton, {
                    label: "Salvar",
                    icon: $data.buttonIcons.save.icon,
                    iconCustomClass: "text-white",
                    width: "w-48 -lg:w-full",
                    type: "submit",
                    disabled: !$data.buttonNewMediatorFee,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.editMediatorFee()))
                  }, null, 8, ["icon", "disabled"])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_155, [
              _createElementVNode("div", _hoisted_156, [
                _hoisted_157,
                _createElementVNode("div", _hoisted_158, [
                  _hoisted_159,
                  _createElementVNode("div", _hoisted_160, _toDisplayString(Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format($props.mediatorFee)), 1)
                ])
              ])
            ]))
      ]),
      ($props.isEdit && !$props.isFinished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
            _hoisted_162,
            _createElementVNode("label", _hoisted_163, [
              _createElementVNode("div", _hoisted_164, [
                _createTextVNode(" Link Onboarding "),
                ($data.invalidResponsavel)
                  ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 0,
                      icon: $data.alert,
                      class: "text-red-500 my-auto ml-auto mr-5 bg-white rounded-full"
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_165, [
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createVNode(_component_CustomInput, {
                      label: "Link Onboarding",
                      name: "onboadingLink",
                      type: "text",
                      readonly: "",
                      disabled: "",
                      class: "col-span-12 sm:col-span-1 lg:col-span-4 xl:col-span-3",
                      value: _ctx.onboardingLink
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  (!$data.linkHasCopied)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        label: "Copiar URL",
                        icon: $data.buttonIcons.copy.icon,
                        width: "w-48 -lg:w-full",
                        type: "button",
                        onClick: $options.handleCopy
                      }, null, 8, ["icon", "onClick"]))
                    : (_openBlock(), _createBlock(_component_PrimaryButton, {
                        key: 1,
                        label: "Copiado",
                        width: "w-48 -lg:w-full",
                        icon: $data.buttonIcons.done.icon,
                        iconCustomClass: "text-white brightness-0 invert",
                        type: "button",
                        onClick: $options.handleCopy
                      }, null, 8, ["icon", "onClick"])),
                  (!$props.isFinished && $props.alreadyRegistered)
                    ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                        key: 2,
                        label: "Reenviar protocolo",
                        icon: $data.buttonIcons.email.icon,
                        iconCustomClass: "text-white",
                        width: "w-48 -lg:w-full",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = () => $data.recoveryProtocolModal = true)
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: "toast-block",
      hidden: $data.hidden,
      onHide: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.hide && $options.hide(...args))),
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($options.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: $data.message,
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($options.hide()), ["self"])),
        success: $data.toastSuccess,
        onHide: $options.hide
      }, null, 8, ["label", "success", "onHide"])
    ], 40, _hoisted_170),
    ($props.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
          _createVNode(_component_Button, {
            label: "Voltar",
            icon: $data.buttonIcons.return.icon,
            width: "w-48 -lg:w-full",
            type: "button",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => { _ctx.$router.go(-1); }, ["prevent"]))
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", $data.recoveryProtocolModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($data.recoveryProtocolModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_172, [
          _hoisted_173,
          _hoisted_174,
          _createElementVNode("div", _hoisted_175, [
            _createVNode(_component_Button, {
              label: "Cancelar",
              icon: $data.buttonIcons.cancel.icon,
              width: "w-48 -lg:w-full",
              type: "button",
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => $data.recoveryProtocolModal = false, ["prevent"]))
            }, null, 8, ["icon"]),
            _createVNode(_component_PrimaryButton, {
              icon: $data.buttonIcons.sendEmail.icon,
              label: "Enviar",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.recovery())),
              iconCustomClass: "text-white",
              class: "ml-2",
              width: "w-48 -lg:w-full",
              type: "submit"
            }, null, 8, ["icon"])
          ])
        ])
      ])
    ], 2)
  ], 64))
}